import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addTrip, deleteTripImage, fetchTripDetailsWithAllData, updateTrip } from "../../../features/admin/tripSlice";
import { fetchServices } from "../../../features/admin/serviceSlice";
import { fetchStays, fetchSubCategoryByCategory, } from "../../../features/admin/placeSlice";
import InnerLoading from "../../ui/InnerLoading";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
const TripModal = () => {
    const { tripId } = useParams<{ tripId: string }>();
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { trip, loading } = useSelector((state: RootState) => state.tripSlice);
    const { stays } = useSelector((state: RootState) => state.placeSlice);
    const { subCategories } = useSelector((state: RootState) => state.placeSlice);
    const { user } = useSelector((state: RootState) => state.user);
    const [imagePreviews, setImagePreviews] = useState<string[]>([]);
    const [showSuccesss, setShowSuccesss] = useState<boolean>(false);
    const [formData, setFormData] = useState({
        fromLocation: "",
        fromLocationAr: "",
        toLocation: "",
        toLocationAr: "",
        fromDate: "",
        toDate: "",
        link: "",
        numberOfAdults: "",
        isPopular:false,
        numberOfChilds: 0,
        numberOfBookings: "",
        numberOfRooms: "",
        price: "",
        details: "",
        detailsAr: "",
        subCategoryId: -1,
        placeId: 0,
        images: [] as File[],
    });
    useEffect(() => {
        if (tripId) {
            dispatch(fetchTripDetailsWithAllData({ tripId: parseInt(tripId) }));
        }
        dispatch(fetchSubCategoryByCategory(5));
        dispatch(fetchServices());
        user?.id && dispatch(fetchStays({userId:user?.id,page:1}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tripId, dispatch]);
    useEffect(() => {
        if (trip && tripId && Object.keys(trip).length > 0) {
            setFormData({
                fromLocation: trip.fromLocation || "",
                fromLocationAr: trip.fromLocationAr || "",
                toLocation: trip.toLocation || "",
                toLocationAr: trip.toLocationAr || "",
                fromDate: trip.fromDate || "",
                toDate: trip.toDate || "",
                link: trip.link || "",
                isPopular: trip.isPopular ||false,
                numberOfAdults: trip.numberOfAdults?.toString() || "",
                numberOfChilds: trip.numberOfChilds || 0,
                numberOfBookings: trip.numberOfBookings?.toString() || "",
                numberOfRooms: trip.numberOfRooms.toString() || "",
                price: trip.price.toString() || "",
                details: trip.details || "",
                detailsAr: trip.detailsAr || "",
                subCategoryId: trip.subCategory?.id || -1,
                placeId: trip.placeId || 0,
                images: [],
            });
            setImagePreviews(trip.tripImages?.map((img) => img.url) || []);
        }
    }, [trip, tripId]);
const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, value, type } = e.target as HTMLInputElement;

  if (type === "checkbox") {
    setFormData({
      ...formData,
      [name]: (e.target as HTMLInputElement).checked,
    });
  } else {
    setFormData({
      ...formData,
      [name]: [
        "numberOfAdults",
        "numberOfChilds",
        "numberOfBookings",
        "numberOfRooms",
        "price",
        "placeId",
        "flightId",
        "subCategoryId"
      ].includes(name)
        ? Number(value)
        : value,
    });
  }
};


    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            setFormData((prev) => ({
                ...prev,
                images: [...prev.images, ...files],
            }));
            setImagePreviews((prev) => [...prev, ...files.map((file) => URL.createObjectURL(file))]);
        }
    };

    const handleImageDelete = (idx: number) => {
        const preview = imagePreviews[idx];
        const isExisting = preview.startsWith("http");

        if (isExisting && trip?.tripImages) {
            const img = trip.tripImages.find((img) => img.url === preview);
            if (img && tripId) {
                img.id && dispatch(deleteTripImage({ tripId: Number(tripId), imageId: img.id }));
            }
        }

        setImagePreviews((prev) => prev.filter((_, i) => i !== idx));
        if (!isExisting) {
            setFormData((prev) => ({
                ...prev,
                images: prev.images.filter((_, i) => i !== idx),
            }));
        }
    };

    const handleSubmit = async () => {
        if (!formData.fromLocation.trim()) return toast.error(t("from-location") + " " + t("required"));
        if (!formData.fromLocationAr.trim()) return toast.error(t("from-locationAr") + " " + t("required"));
        if (!formData.toLocation.trim()) return toast.error(t("to-location") + " " + t("required"));
        if (!formData.toLocationAr.trim()) return toast.error(t("to-locationAr") + " " + t("required"));
        if (Number(formData.numberOfAdults) < 1) return toast.error(t("numberOfAdults") + " " + t("required"));
        if (!formData.fromDate) return toast.error(t("from-date") + " " + t("required"));
        if (!formData.toDate) return toast.error(t("to-date") + " " + t("required"));
        if (new Date(formData.toDate) < new Date(formData.fromDate)) {
            return toast.error(t("to-date-must-be-after-from-date"));
        }

        if (!formData.subCategoryId || formData.subCategoryId === -1)
            return toast.error(t("select-subCategory"));

        if (!formData.placeId || formData.placeId === 0)
            return toast.error(t("select-place"));

        if (Number(formData.numberOfRooms) < 1)
            return toast.error(t("rooms-must-be-at-least-one"));

        if (Number(formData.numberOfBookings) < 1)
            return toast.error(t("bookings-must-be-at-least-one"));

        if (Number(formData.price) <= 0)
            return toast.error(t("price-must-be-positive"));

        if (!formData.details.trim())
            return toast.error(t("details") + " " + t("required"));

        if (!formData.detailsAr.trim())
            return toast.error(t("detailsAr") + " " + t("required"));


        if (imagePreviews.length === 0) {
            return toast.error(t("at-least-one-image-required"));
        }

        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => {
            if (key === "images") return;
            data.append(key, String(val));
        });
        formData.images.forEach((file) => data.append("images", file));

        if (trip && tripId) {
            dispatch(updateTrip({ id: trip.id, data }));
            navigate(`/dashboard/trip-details/${tripId}`)
        } else {
            dispatch(addTrip(data));
            setShowSuccesss(true)
        }
    };



    if (loading) return <InnerLoading />;

    return (
        <div className=" ">
            <h2 className='bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
                {tripId ? t("edit-Trip") : t("create-Trip")}
            </h2>

            <div className="space-y-4 w-full p-4 bg-white rounded-lg">
                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div>
                        <label className="block mb-1 font-medium">{t("from-location")}</label>
                        <input name="fromLocation" value={formData.fromLocation} onChange={handleChange} className="input-field" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("from-locationAr")}</label>
                        <input name="fromLocationAr" value={formData.fromLocationAr} onChange={handleChange} className="input-field" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("to-location")}</label>
                        <input name="toLocation" value={formData.toLocation} onChange={handleChange} className="input-field" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("to-locationAr")}</label>
                        <input name="toLocationAr" value={formData.toLocationAr} onChange={handleChange} className="input-field" />
                    </div>

                </div>
                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div className="flex-1">
                        <label className="block mb-1 font-medium">{t("from-date")}</label>
                        <input type="date" name="fromDate" value={formData.fromDate} onChange={handleChange} className="input-field" />
                    </div>
                    <div className="flex-1">
                        <label className="block mb-1 font-medium">{t("to-date")}</label>
                        <input type="date" name="toDate" value={formData.toDate} onChange={handleChange} className="input-field" />
                    </div>
                </div>

                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div>
                        <label className="block  mb-1">{t("subCategory")}</label>
                        <select name="subCategoryId" value={formData.subCategoryId} onChange={handleChange} className="input-field px-4">
                            <option className=" text-grayColor" disabled value={-1}>{t("select-subCategory")} </option>
                            {subCategories?.map((subCategory: any) => (
                                <option key={subCategory.id} value={subCategory.id}>{subCategory.title}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("select-place")}</label>
                        <Listbox value={formData.placeId} onChange={(val: any) => handleChange({ target: { name: "placeId", value: val } } as any)}>
                            <div className="relative">
                                <ListboxButton className="input-field flex items-center gap-2">
                                    {stays.find(p => p.id === formData.placeId)?.images?.[0] && (
                                        <img
                                            src={stays.find(p => p.id === formData.placeId)?.images?.[0].url}
                                            alt="place"
                                            className="w-6 h-6 rounded object-cover"
                                        />
                                    )}
                                    {stays.find(p => p.id === formData.placeId)?.title || t("select-place")}
                                </ListboxButton>

                                <ListboxOptions
                                    className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded max-h-60 overflow-y-auto"
                                >
                                    {stays.map((p) => (
                                        <ListboxOption key={p.id} value={p.id}>
                                            {({ selected }: any) => (
                                                <div className={`flex items-center gap-2 p-2 ${selected ? 'bg-gray-100' : ''}`}>
                                                    <img src={p.images?.[0].url} alt={p.title} className="w-6 h-6 rounded object-cover" />
                                                    <span>{p.title}</span>
                                                </div>
                                            )}
                                        </ListboxOption>
                                    ))}
                                </ListboxOptions>
                            </div>
                        </Listbox>

                    </div>

                </div>

                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div>
                        <label className="block mb-1 font-medium">{t("adults")}</label>
                        <input
                            type="number"
                            name="numberOfAdults"
                            value={formData.numberOfAdults}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("children")}</label>
                        <input
                            type="number"
                            name="numberOfChilds"
                            value={formData.numberOfChilds}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                </div>
                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div>
                        <label className="block mb-1 font-medium">{t("number-of-rooms")}</label>
                        <input
                            type="number"
                            name="numberOfRooms"
                            value={formData.numberOfRooms}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("number-of-bookings")}</label>
                        <input
                            type="number"
                            name="numberOfBookings"
                            value={formData.numberOfBookings}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                </div>
                <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4">
                    <div>
                        <label className="block mb-1 font-medium">{t("link")}</label>
                        <input name="link" value={formData.link} onChange={handleChange} className="input-field" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">{t("price")}</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                </div>
                <div className="flex items-end pb-2 gap-2">
                    <input
                        type="checkbox"
                        name="isPopular"
                        checked={formData.isPopular || false}
                        onChange={handleChange}
                        className="w-5 h-5"
                    />
                    <label className="text-gray-600">{t("is-popular-trip")}</label>
                </div>
                <div>
                    <label className="block mb-1 font-medium">{t("details")}</label>
                    <textarea
                        name="details"
                        value={formData.details}
                        onChange={handleChange}
                        className="input-field"
                    />
                </div>
                <div>
                    <label className="block mb-1 font-medium">{t("detailsAr")}</label>
                    <textarea
                        name="detailsAr"
                        value={formData.detailsAr}
                        onChange={handleChange}
                        className="input-field"
                    />
                </div>

                <div className="mb-6">
                    <label className="block text-gray-600 mb-2">{t("upload-images")}</label>

                    <div className="flex items-center gap-4 mb-4 flex-wrap">
                        {imagePreviews.map((src, idx) => (
                            <div
                                key={idx}
                                className="relative w-28 h-28 rounded-lg border border-gray-300 overflow-hidden shadow-sm group"
                            >
                                <img
                                    src={src}
                                    alt={`preview-${idx}`}
                                    className="w-full h-full object-cover"
                                />
                                <button
                                    onClick={() => handleImageDelete(idx)}
                                    className="absolute top-1 right-1 bg-red-500 text-white w-6 h-6 rounded-full text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}

                        <label className="w-28 h-28 flex items-center justify-center border border-dashed border-gray-400 rounded-lg cursor-pointer hover:border-primary transition">
                            <span className="text-gray-500 text-sm text-center px-2">{t("add-image")}</span>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleImageChange}
                                className="hidden"
                            />
                        </label>
                    </div>
                    <div className="flex justify-end">
                        <button
                            onClick={handleSubmit}
                            className="bg-primary hover:bg-primary-dark transition text-white px-8 py-3 rounded-lg text-sm font-medium shadow-md"
                        >
                            {tripId ? t("update") : t("create")}
                        </button>
                    </div>
                </div>
            </div>
            {
                showSuccesss &&
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
                    <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
                        <div className=' flex gap-10 flex-col items-center justify-between w-full '>
                            <div className=' text-center'>
                                <h2 className='text-xl font-semibold mb-2'>{t("trip-added")}</h2>
                                <p className=' mb-2'>{t("back-trips")}</p>
                                <div className=' w-full flex-center'>
                                    <div className=' w-24'>
                                        <img src="/asset/success.png" className=' w-full' alt="success" loading='lazy' />
                                    </div>
                                </div>

                            </div>
                            <Link className=' text-white bg-primary rounded-lg py-2 text-center w-full' to={`/dashboard/trips`}>{t("continue")}</Link>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default TripModal;
